import { EntryTypes } from "./constants";

export const getAutoGeneratedDescription = (entryType, data, currentUser) => {
  const descriptions = {
    [EntryTypes.AccSession]: () => 
      `Acc.Session Id: ${data.id}, Patient Name: ${data.getPatient.getUser.name}, ` +
      `Patient Id: ${data.patientId}, User Id: ${data.getPatient.getUser.id}, ` +
      `Original Price: EGP${data.originalPrice}, Discount %: ${data.discount}, ` +
      `Final Price: EGP${data.finalPrice}, This entry was created by --> ` +
      `Id: ${currentUser.id}, Name: ${currentUser.name}`,

    [EntryTypes.Package]: () =>
      `Package Id: ${data.id}, Patient Name: ${data.getPatient.getUser.name}, ` +
      `Patient Id: ${data.patientId}, User Id: ${data.getPatient.getUser.id}, ` +
      `Original Price: EGP${data.originalPrice}, Discount %: ${data.discount}, ` +
      `Final Price: EGP${data.finalPrice}, Created By: ${currentUser.id}, ` +
      `Name: ${currentUser.name}`,

    [EntryTypes.AccThHour]: () =>
      `AccThHourId: ${data.id}, Therapist Name: ${data.getTherapist.getUser.name}, ` +
      `TherapistId: ${data.therapistId}, UserId: ${data.getTherapist.getUser.id}, ` +
      `PricePerHour: EGP${data.pricePerHour}, Final Price: EGP${data.finalPrice}, ` +
      `AccSessionId: ${data.accountingSessionId}, Created By: ${currentUser.id}, ` +
      `Name: ${currentUser.name}`,
  };

  return descriptions[entryType] ? descriptions[entryType]() : "";
};

export const getAutoGeneratedTitle = (entryType) => {
  const titles = {
    [EntryTypes.AccSession]: "Auto Generated Acc.Session Entry",
    [EntryTypes.Package]: "Auto Generated Package Entry",
    [EntryTypes.AccThHour]: "Auto Generated AccThHour Entry",
  };

  return titles[entryType] || "";
};

export const getCategoryForEntryType = (entryType) => {
  const categories = {
    [EntryTypes.AccSession]: "Accounting Sessions",
    [EntryTypes.Package]: "Packages",
    [EntryTypes.AccThHour]: "Accounting Therapist Hours",
  };

  return categories[entryType] || "";
};